export const APP_RESOURCE = 'APP_RESOURCE'

export const STAR_MAP = 'STAR_MAP'

export const WORKSPACE = 'WORKSPACE'

export const TEMPLATE = 'TEMPLATE'

export const THEME = 'THEME'
